import {
  Button,
  Card,
  CardContent,
  Grid,
  Link,
  Typography,
} from "@material-ui/core";
import { ECOQUBE_PRICE, ECOQUBE_SUBSCRIPTION_PRICE } from '../../../constants/values';

const Pricing = () => {
  return (
    <Card mb={6}>
      <CardContent>
        <Grid container direction="column" spacing={4}>
          <Grid item>
            <Typography variant="h5">EcoGuard Pricing</Typography>
          </Grid>
          <Grid item>
            <Typography variant="body1" style={{ fontSize: "14px" }}>
              <ul style={{ paddingLeft: "2em" }}>
                <li>
                  Hardware regular price (EQ200EG):
                  <ul style={{ paddingLeft: "2em", listStyleType: "disc" }}>
                    <li>
                      <strong>${ECOQUBE_PRICE}.00/unit</strong> (includes dashboard subscription for 1st year)
                    </li>
                  </ul>
                </li>
              </ul>
              <ul style={{ paddingLeft: "2em" }}>
                <li>Subscription renewal price</li>
                <ul style={{ paddingLeft: "2em", listStyleType: "disc" }}>
                  <li>
                    <strong>${ECOQUBE_SUBSCRIPTION_PRICE}.00/year</strong>
                  </li>
                </ul>
              </ul>
              <ul style={{ paddingLeft: "2em" }}>
                <li>
                  Please contact us (
                  <Link href="mailto:sale@ecosense.io">sale@ecosense.io</Link>)
                  for bulk purchases.
                </li>
              </ul>
            </Typography>
          </Grid>
        </Grid>
      </CardContent>
    </Card>
  );
};

export default Pricing;
